import { useQuery } from '@tanstack/react-query';
import { getDepartmentsByLibrary, getFilesByDepartment, getLibrariesByCompany } from '../axiosNetworkRequest/library';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useGetLibrariesByCompany = (company_id: number) => {
  return useQuery({
    queryKey: ['libraries-by-company', company_id],
    queryFn: () => getLibrariesByCompany(`user/get-libraries-by-company?company_id=${company_id}`),
    staleTime: FIVE_MINUTES,
    enabled: company_id > 0,
  });
};

export const useGetDepartmentsByLibrary = (library_id: number) => {
  return useQuery({
    queryKey: ['departments-by-library', library_id],
    queryFn: () => getDepartmentsByLibrary(`user/get-departments-by-library?library_id=${library_id}`),
    staleTime: FIVE_MINUTES,
  });
};

export const useGetFilesByDepartment = (department_id: number) => {
  return useQuery({
    queryKey: ['files-by-department', department_id],
    queryFn: () => getFilesByDepartment(`user/get-files-by-department?department_id=${department_id}`),
    staleTime: FIVE_MINUTES,
  });
};
